import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./product.scss";

// for Localization
import { withTranslation, useTranslation } from "react-i18next";
// @mui
import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import Remove from "@mui/icons-material/Remove";
import { RootState } from "../../store/reducers";
import { actionCreators } from "../../store";
import { bindActionCreators } from "redux";
import { apiService } from "../../services";
import { get_lang } from "../../helper/getLang";
import { v4 as uuidv4 } from "uuid";
import EditIcon from "@mui/icons-material/Edit";
import ExtrasFieldsPopup from "../ExtrasFieldsPopup/ExtrasFieldsPopup";
import noImage from "../../assets/images/no-image.svg";
const Product = (props: any) => {
  const { t } = useTranslation();
  const { item, ind, handleGetCart, handleIncrement, handleDecrement, handleRemove } = props;

  const appState  = useSelector((state: RootState) => state.apiReducer);
  const state = useSelector((state: RootState) => state.appReducer);
  const [quantityValue, setQuantityValue] = useState(1);
  const dispatch = useDispatch();
  const { setExtrasFieldsPopup, setExtrasFields, freezScreenState } =
    bindActionCreators(actionCreators, dispatch);
const [localState, setLocalState] :any = useState([])
  const [apiLoading, setApiLoading] = useState(false);
  const handleAddToCartWithField = async (bookingExtra: any) => {
    try {
      setApiLoading(true);
      const res = await apiService.getBookingFieldsExtras(
        bookingExtra?.extra_id
      );
      if (res?.data.success == true) {
        let cart_id = uuidv4();
        var currentCart = {
          id: cart_id,
          booking_extra_id: bookingExtra?.extra_id,
          extra_id: bookingExtra?.extra_id,
          quantity: 1,
          values: [],
          price: bookingExtra?.price,
          image: bookingExtra?.image,
          maxQuantity: bookingExtra?.quantity,
          prod_title: bookingExtra.extra,
        };

        if (res?.data?.data.length == 0) {
          handleGetCart(null, bookingExtra);
        } else {
          handleGetCart('hasField', bookingExtra);
          setExtrasFields(res?.data?.data);
          setExtrasFieldsPopup(true);
          freezScreenState(true);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setApiLoading(false);
    }
  };

  return (
    <>
      <div key={ind} className=" d-flex my-3" id="ProductArrived">
        <div className="d-flex align-items-center">
          <img
            src={item?.image ? item?.image : noImage}
            alt="sushi"
            width={72}
            height={72}
            className="orderImage"
          />
          <div className="d-flex flex-column">
            <h4
              className={`  text-capitalized catName familysora600 mt-2 px-2  `}
            >
              {get_lang(item?.extra, state.langValue)} :
            </h4>{" "}
            <h6
              className={` textOver text-capitalized priceAmoutn familysora700 mt-1 px-2   `}
            >
              {item?.price > 0 && item?.price != null ? ` ${item?.price} 
              ${get_lang(appState.storeInfo.storeCurrency, state.langValue)} ` : ""}
             
            </h6>
          </div>
        </div>

        <div className="Addbutton">
          {item?.quantity > 0 && item?.hasFields > 0 ? (
           <span>
           {" "}
           <IconButton onClick={() => handleRemove(item)}>
             {/* {item?.quantity > 1 ? <Remove className=""  /> : <DeleteIcon/>} */}
             <DeleteIcon className=" " />
           </IconButton>{" "}
           {item?.quantity}{" "}
           <IconButton
             onClick={() => handleAddToCartWithField(item)}
             disabled={item.check_status}
           >
             <EditIcon className=" " />
           </IconButton>{" "}
         </span>
          ) : item?.quantity == 0 ? (
            <IconButton
              onClick={() =>
                item?.hasFields > 0
                  ? handleAddToCartWithField(item)
                  : handleGetCart(null, item)
              }
            >
              <AddIcon />
            </IconButton>
          ) : (
            <span>
              {" "}
              <IconButton onClick={() => handleDecrement(item)}>
                {item?.quantity > 1 ? <Remove className=" " /> : <DeleteIcon/>}
              </IconButton>{" "}
              {item?.quantity}{" "}
              <IconButton
                onClick={() => handleIncrement(item)}
                disabled={item.check_status}
              >
                <AddIcon className=" " />
              </IconButton>{" "}
            </span>
          )}
        </div>
      </div>
    
    </>
  );
};

export default withTranslation()(Product);
